/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/MorePagesTitle/theme';

export const MorePagesTitleTheme = theme;
